import { Injectable } from '@angular/core';
import {Gov} from './gov';
import {  MessageService, HttpGeneralService } from '../../../shared';
import { CONFIG } from '../../../shared/config';

let govsUrl = CONFIG.baseUrls.govsLink;



@Injectable()
export class GovService {
    constructor(private httpGeneralService: HttpGeneralService) {}


    getGovs(serial: number = 0) {

        return this.httpGeneralService.get(serial, govsUrl)
    }
    searchGovs(k?: string, paramObj?: any) {
        let countryCode = 0;
        let keyword = k || " ";
        return this.httpGeneralService.getWith(`${govsUrl}/search/${countryCode}/${keyword}`)
    }
    searchCountries(k?: string, offset?: number) {
        let keyword = k || " ";
        return this.httpGeneralService.getWith(`${govsUrl}/search/${keyword}/${offset}`)
    }

    addGov(country: Gov) {
        return this.httpGeneralService.add<Gov>(country, govsUrl)
    }


    getGov(id: number) {
        return this.httpGeneralService.get(id, govsUrl)
    }


    updateGov(country: Gov) {
        return this.httpGeneralService.update<Gov>(country.code, country, govsUrl)
    }

    deleteGov(country: Gov) {

        return this.httpGeneralService.delete<number>(country.code, `${govsUrl}`)

    }

}
